export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/dragging-icon.svg?01b80fe8718a374509a39e2116e31e8d";